"use client"
import "aos/dist/aos.css"
import Title from "../Title/Title"

function Alliance() {
  return (
    <article
      className="px-5 xl:px-16 3xl:px-24 py-16 bg-white"
      data-aos="fade-up"
      data-aos-duration="1000"
      data-aos-delay="400"
    >
      <div className="flex flex-col xl:flex-row justify-between w-full pb-16 border-b border-b-[--color-gray]">
        <div className="flex xl:w-2/3">
          <Title
            type="h2"
            className="uppercase text-[24px] xl:text-[60px]"
            title="Certifications"
          />
        </div>
        <div className="flex xl:w-1/3 items-center gap-2 pe-[24px]">
          <p className="2 ">
            At Cyberstone, our industry-recognized cybersecurity certifications
            showcase our unwavering commitment to data protection, information
            security, and regulatory compliance. Each certification highlights
            our dedication to excellence, continuous improvement, and the trust
            clients place in us to protect their digital assets from
            ever-evolving cyber threats.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-7  gap-24 mt-16 justify-around items-center">
        {/* Render alliance images a-1.png to a-18.png */}
        {Array.from({ length: 29 }, (_, i) => (
          <img
            key={i}
            src={`/certificates/cert-${i + 1}.png`}
            width={100}
            height={52}
            alt={`Security certification ${i + 1}`}
            loading="lazy"
            decoding="async"
          />
        ))}
      </div>
    </article>
  )
}

export default Alliance
